module.exports = "/_next/static/images/Sergiu_Curea-ff2027521a92d87b35ab3e9578ff507c.webp";